var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:_vm.id,class:[
        {
            'open': _vm.accordionOpen,
        },
        `
            block
            w-full
            py-4
            cursor-pointer
            border-0
            border-solid
            border-b-2
            border-primary
        `
    ],on:{"click":_vm.toggleAccordion}},[_c('h3',{staticClass:"flex items-center justify-between mb-0 text-primary accordion-title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('ui-icon',{staticClass:"text-sm",attrs:{"icon":"chevron-down"}})],1),_vm._v(" "),_c('div',{staticClass:"accordion-inner mt-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }